"use client";

import { Company } from "@entities/employer";
import { EmptyScreen } from "@shared/cms";
import { Collection } from "@shared/types";
import { CompanyListGridConfig } from "../../types";
import { DefaultCompanyListGrid } from "./default-company-list-grid";

export function CompanyListGrid({ initialData, config }: { initialData: Collection<Company> | null; config: CompanyListGridConfig }) {
  // All company data (including keyword searches) is served by the API
  if (!initialData) {
    return <EmptyScreen {...config.emptyScreen} />;
  }

  return <DefaultCompanyListGrid collection={initialData} config={config} />;
}
